import { faChartSimple } from '@fortawesome/free-solid-svg-icons';
import { useUserContext } from 'contexts/UserContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppPage } from 'view/components/common/AppPage';
import PanelButton from 'view/components/common/PanelButton';
import AppSidebar from 'view/components/common/Sidebar';

const DistrictAdminHome: React.FC = () => {
  const { user } = useUserContext();
  const navigate = useNavigate();

  if (!user) return <AppPage />;

  return (
    <AppPage>
      <div className="app-page-content">
        <AppSidebar user={user} />
        <div className="app-main-content">
          <h1>Staff Home</h1>

          <div className="classroom-list">
            <PanelButton
              label="Analytics"
              icon={faChartSimple}
              onClick={() => navigate('/admin/analytics')}
            />
          </div>
        </div>
      </div>
    </AppPage>
  );
};

export default DistrictAdminHome;
